import { eDmHeActionsObj } from "../../action-types/category/IDmHeActions";
import { generateActions, generateActionForKey } from "../generateActions";
import { NotifyHelper } from "../../../helpers/toast";

export const heActions = {
  ...generateActions(eDmHeActionsObj, "HE"),
  ...generateActionForKey(eDmHeActionsObj, "HE", "SAVE_SUCCESS", () => {
    NotifyHelper.Success("Thành công");
  }),
  ...generateActionForKey(eDmHeActionsObj, "HE", "DELETE_SUCCESS", () => {
    NotifyHelper.Success("Thành công");
  }),
  ...generateActionForKey(eDmHeActionsObj, "HE", "SAVE_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
  ...generateActionForKey(eDmHeActionsObj, "HE", "DELETE_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
};
